import React from "react";
import { PromoSliders } from "./promoSlider";
import { CategorySliders } from "./hSlider";
import { SlideFull } from "./hSlider2";
import { NewCollections } from "./newCollection";


export const Home = () => {
  
  return (
    <div className="main custom-scroll">
      <PromoSliders />
      <CategorySliders cat="Categories"/> 
      <SlideFull cat="Shirt Collection" type="shirts"/>
      <SlideFull cat="Jeans Collection" type="jeans"/>
      <NewCollections cat="New Collection"/>
    </div>
    
  );
};
